import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=60e6740d&"
import script from "./Notifications.vue?vue&type=script&lang=ts&"
export * from "./Notifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports